/**
 * Fetches the information of the bill that is about to be sent.
 */

import Vue from 'vue';
import emailTransformer from './../../transformers/email';

const success = ({ data }, resolve) => resolve(emailTransformer.fetch(data));

const failed = () => {};

export default id => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`/invoices/${id}/showBillEmailInformation`)
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/invoice/showBillEmailInformation.js